import { sliceAddress } from '@utils/strings'
import { LeaderboardTableElement, LeaderboardUser } from '../types'

const buildUpLeaderboardTableData = (
  leaderboard: Array<LeaderboardUser>,
  currentUserInfo: LeaderboardUser
): Array<LeaderboardTableElement> => {
  const updatedLeaderboard = [
    ...(currentUserInfo.position > 0
      ? [
          {
            rank: currentUserInfo.position,
            member: {
              avatarUrl: currentUserInfo.avatarUrl,
              wallet: currentUserInfo.firstName || sliceAddress(currentUserInfo.walletAddress as string, 5)
            },
            XP: currentUserInfo.xp
            // questsCompleted: currentUserInfo.completedQuestsCount,
            // badges: currentUserInfo.badgeCount
          }
        ]
      : []),
    ...leaderboard.map((user) => ({
      rank: user.position,
      member: {
        avatarUrl: user.avatarUrl,
        wallet: user.firstName || sliceAddress(user.walletAddress as string, 5)
      },
      XP: user.xp
      // questsCompleted: user.completedQuestsCount,
      // badges: user.badgeCount
    }))
  ]

  return updatedLeaderboard
}

export { buildUpLeaderboardTableData }
